import { Link } from 'react-router-dom'

import logo from '@/assets/images/home/logo-cnrppn.png'
import { Button } from '@/components/button'
import { ForestIcon } from '@/components/icons/forest'

export function NationalConfederationBanner() {
  return (
    <div className="h-full bg-cnrppnBanner bg-cover">
      <div className="h-full">
        <div className="flex h-full flex-col-reverse items-center justify-between gap-5 xl:flex-row">
          <div className="flex h-full flex-col items-center justify-center gap-5 px-5 py-5 xl:w-1/2 xl:items-start xl:justify-start xl:px-40 xl:py-20">
            <span className="bg-bios-100 flex items-center gap-2 rounded-lg p-2 text-center font-bold text-bios-secondary xl:text-start">
              <ForestIcon />
              CNRPPN e 6BIOS
            </span>
            <h1 className="text-center text-2xl font-bold text-white md:text-4xl xl:text-start">
              Conservar de forma afetiva os biomas brasileiros
            </h1>
            <div className="flex flex-1 items-center text-center xl:text-start">
              <p className="my-auto text-lg text-white">
                A 6BIOS e a Confederação Nacional das Reservas Particulares do
                Patrimônio Natural - CNRPPN, realizam parceria para
                fortalecimento da RPPNs do Brasil.
              </p>
            </div>
            <Button
              variant="outline"
              className="cursor-not-allowed border border-bios-primary bg-transparent font-normal uppercase text-white"
              asChild
            >
              <Link to="#">Saiba mais</Link>
            </Button>
          </div>
          <img
            src={logo}
            alt="Logo da CNRPPN"
            className="mx-auto mt-5 h-1/3 object-cover xl:mr-32 xl:mt-0 xl:h-1/2"
          />
        </div>
      </div>
    </div>
  )
}
